export enum ClientTaskType {
  RESEND_QUESTIONAIRE_FAILED = "resendQuestionaireFailed",
  RESEND_QUESTIONAIRE_SUCCESS = "resendQuestionaireSuccess",
}
